import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NavService } from '../../services/nav.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() isDarkMode: boolean = false;

  userName: string = '';
  company: string = '';

  constructor(
    private store: Store<any>,
    public authService: AuthService,
    public router: Router,
    private navServices: NavService
  ) {}

  data$ = this.store.select('data');
  totalMoney: any = 0;
  totalLength = 1;
  delectFunction = false;

  price() {
    this.data$.forEach((item: string | any[]) => {
      this.totalLength = item.length;
      if (item.length > 1) {
        this.totalMoney =
          this.totalMoney + item[this.totalLength - 1]?.offer_price;
      } else {
        if (item[0]?.offer_price != undefined) {
          this.totalMoney = item[0].offer_price;
        }
      }
      if (this.delectFunction) {
        this.totalMoney = 0;
        this.delectFunction = false;
      }
    });
  }

  ngOnInit(): void {
    this.userName = this.authService.getName().split(' ', 1)[0];
    this.company = this.authService.getCompany();
  }
  toggleSidebar() {
    if ((this.navServices.collapseSidebar = true)) {
      document.querySelector('body')?.classList.toggle('sidenav-toggled');
    }
  }

  async logOut() {
    this.authService.revokeToken();
    this.authService.clearStorage();
    this.router.navigate(['auth/login']);
  }
}
